<template>
  <div class="posts-page">

    <hero-section-blog
      :fields="blogsPageSections.sections.blogs_hero_section.fields"
    />

    <div class="posts-section">
      <div class="main-container">
        <div class="posts-section-header">
          <category-filter
            :value="selectedCategory ? selectedCategory.id: null"
            :categories="categories"
            @input="selectCategory"
          />

          <div class="search-bar">
            <input  v-model="searchPost" class="paragraph-1-large" :placeholder="$t('blog.search')" @input="listPosts">
            <button class="search-bar-button">
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M19.5 9.75C19.5 11.9062 18.7969 13.9219 17.625 15.5156L23.5312 21.4688C24.1406 22.0312 24.1406 23.0156 23.5312 23.5781C22.9688 24.1875 21.9844 24.1875 21.4219 23.5781L15.4688 17.625C13.875 18.8438 11.8594 19.5 9.75 19.5C4.35938 19.5 0 15.1406 0 9.75C0 4.40625 4.35938 0 9.75 0C15.0938 0 19.5 4.40625 19.5 9.75ZM9.75 16.5C13.4531 16.5 16.5 13.5 16.5 9.75C16.5 6.04688 13.4531 3 9.75 3C6 3 3 6.04688 3 9.75C3 13.5 6 16.5 9.75 16.5Z"
                  fill="#F4F5F5"/>
              </svg>
            </button>
          </div>
        </div>

        <posts-grid
          :posts="posts"
          @viewPost="openPostDetailsPage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import HeroSectionBlog from "/seu-frontend/sections/blog-page/HeroSectionBlog";
import CategoryFilter from "../../modules/blog/components/CategoryFilter";
import PostsGrid from "../../modules/blog/components/PostsGrid";
import {stripTypenames} from "../../services/utils";
import {mapState} from "vuex";

function debounce(func, timeout = 300){
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}
export default {
  name: "PostsPage",
  components: {PostsGrid, CategoryFilter, HeroSectionBlog},
  props:{
    categorySlug:{
      type: String
    }
  },
  data: () => ({searchPost: ''}),

  computed: {
    ...mapState('post', ['pagination', "posts"]),
    ...mapState('categories', ['pagination', "categories"]),
    blogsPageSections() {
      return require(`../../services/pages/${this.$store.state.currentLanguage.toLowerCase()}/blogsPage`).default;
    },
    ...mapState({
      defaultLanguage: state => state.defaultLanguage.toLowerCase(),
    }),
    selectedCategory(){
      if (!this.categorySlug) {
        return null;
      }
      return this.categories.find(cat => (cat.details && cat.details.slug === this.categorySlug) || cat.defaultTranslation.slug === this.categorySlug )
    }
  },
  methods: {
    listCategories() {
      return this.$store.dispatch('categories/listCategories')
    },

    openPostDetailsPage(post) {
      this.$router.push({
        name: "PostDetailsPage",
        params: {
          slug: post.details.slug,
          lang: this.$route.params.lang
        }
      })
    },
    listPosts() {
      return this.$store.dispatch('post/listPosts', {
        ...this.selectedCategory && {
          filter: {
            categoryIds: [this.selectedCategory.id]
          }
        },
        search: this.searchPost,
        pagination: {
          page: this.pagination.page,
          rowsPerPage: this.pagination.rowsPerPage,
          sortBy: stripTypenames(this.pagination.sortBy)
        }
      })
    },
    selectCategory(category){
      if ((!this.selectedCategory && !category) || (this.selectedCategory &&  category && this.selectedCategory.id  === category.id)) {
        return
      }
      if (category) {
        const categorySlug = (category.details && category.details.slug) ? category.details.slug : category.defaultTranslation.slug
        this.$router.push({name:'CategoryPostsPage', params:{...this.$route.params,categorySlug}})
      } else {
        this.$router.push({name:'PostsPage', params:{lang:this.$route.params.lang}})
      }
    }
  },
  metaInfo() {
    return {
      title: this.blogsPageSections.title
    }
  },
  created() {
    this.listCategories()
    .then(({result}) => {
      this.listPosts()
    }).then(() => {
      this.listPosts = debounce(this.listPosts)
    })
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.lang === from.params.lang || to.name !== 'CategoryPostsPage' || to.params.categorySlug !== from.params.categorySlug) {
      return next()
    } else {
      const lang = to.params.lang ?  to.params.lang: this.defaultLanguage;

      let translation = this.selectedCategory.translations.find(tr => tr.lang.toLowerCase()===lang);
      let slug = translation ? translation.slug : this.selectedCategory.defaultTranslation.slug;
      if (slug === to.params.categorySlug) {
        next()
      } else {
        next({
          ...to,
          params: {
            ...to.params,
            categorySlug: translation ? translation.slug : this.selectedCategory.defaultTranslation.slug
          }
        })
      }
    }
  },
}
</script>

<style lang="scss">
@import "PostsPage";
</style>
